import * as z from 'zod'
import { TFunction } from 'i18next'
import { isEmail } from 'src/utils/contact'
import { CreditType } from 'src/api/api.generated'

export function getReservationNewFormSchema(t?: TFunction) {
  const schema = z
    .object({
      reservation: z
        .object({
          checkIn: z.date().nullable(),
          checkOut: z.date().nullable(),
        })
        .refine((data) => data.checkIn && data.checkOut && data.checkIn < data.checkOut),
      nights: z.number().min(1),
      adults: z.number(),
      children: z.array(z.object({ childId: z.string(), quantity: z.number() })).optional(),
      notes: z.string().default(''),
      customerCompanyId: z.string().nullable().default(null),
      customerPersonId: z.string(),
      isOptioned: z.boolean(),
      optionedExpirationDate: z.date().nullable().optional(),
      disableAutomation: z.boolean(),
      customerEmailAddress: z.string().nullable().optional(),
      credit: z.nativeEnum(CreditType).default(CreditType.NC),
    })
    .superRefine((data, ctx) => {
      if (data.isOptioned && !data.optionedExpirationDate) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: t?.('validation.required_error'),
          path: ['optionedExpirationDate'],
        })
      }

      if (!data.disableAutomation && !isEmail(data.customerEmailAddress)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: t?.('validation.invalid_email'),
        })
      } else {
        return
      }
    })

  return schema
}

const schema = getReservationNewFormSchema()
export type ReservationSchema = z.TypeOf<typeof schema>
